export enum PagesActionTypes {
  INITIALIZED = 'pages/INITIALIZED',
  DESTROYED = 'pages/DESTROYED',
  RECEIVED = 'pages/RECEIVED',
  REQUEST = 'pages/REQUEST',
  FILTER = 'pages/FILTER',
  NEXT_RECEIVED = 'pages/NEXT_RECEIVED',
  NEXT_REQUEST = 'pages/NEXT_REQUEST',
}
